import { ESdChangeReason } from "@kuika/kuika-cl-model";
import { Guid } from "guid-typescript";
import { Component, ReactNode } from "react";

export class ReactPartial<PartialComponent extends Component<PartialProps>, PartialProps, PartialState, OwnState> {
  protected readonly partial: PartialComponent;

  constructor(partial: PartialComponent) {
    this.partial = partial;
  }

  get state(): PartialState & OwnState {
    return this.partial.state as PartialState & OwnState;
  }

  get props(): Readonly<PartialProps> & Readonly<{ children?: ReactNode }> {
    return this.partial.props;
  }

  setState = <K extends keyof PartialState & OwnState>(
    state:
      | ((
          prevState: Readonly<PartialState & OwnState>,
          props: Readonly<PartialProps>
        ) => Pick<PartialState & OwnState, K> | (PartialState & OwnState) | null)
      | (Pick<PartialState & OwnState, K> | (PartialState & OwnState) | null),
    callback?: () => void
  ) => {
    if (typeof state === "object") {
      const temp = state;
      if ((temp as any).changeReason === undefined) {
        (temp as any).changeReason = ESdChangeReason.OtherSetStates;
      }
      if ((temp as any).changeReasonParameter === undefined) {
        (temp as any).changeReasonParameter = Guid.create().toString();
      }
      this.partial.setState(temp, callback);
    } else {
      this.partial.setState(state as any, callback);
    }
  };

  forceUpdate = () => {
    this.partial.forceUpdate();
  };
}

export abstract class ReactPartialProtected<
  ContextProvider extends Component<ContextProviderProps>,
  ContextProviderProps,
  ProtectedState
> extends ReactPartial<ContextProvider, ContextProviderProps, ProtectedState, ProtectedState> {}
